import { useTranslation } from "react-i18next";

const WILDCARD = ".*";

/** Grouped tool catalogue: built-in tools, then one group per connection (pick the whole
 * connection with `slug.*` or single actions). Saved tools the user can no longer pick are
 * listed disabled with the reason, so nothing disappears silently. */
export default function ToolPicker({ catalogue, selected, onChange, problems = {}, loaded = false }) {
  const { t } = useTranslation();
  const known = new Set(catalogue.map((e) => e.name));
  const groups = [];
  catalogue.forEach((entry) => {
    const group = groups.find((g) => g.name === entry.group);
    if (group) group.entries.push(entry); else groups.push({ name: entry.group, entries: [entry] });
  });
  const toggle = (name) => onChange(selected.includes(name) ? selected.filter((n) => n !== name) : [...selected, name]);
  const label = (entry) => (entry.name.endsWith(WILDCARD)
    ? t("agents.toolWholeConnection", { name: entry.group }) : entry.name);
  const reason = (name) => problems[name] && t(`agents.reason_${problems[name]}`);
  const unavailable = loaded ? selected.filter((name) => !known.has(name)) : [];

  return (
    <fieldset className="ac-detail-section">
      <legend className="ds-label">{t("agents.fieldTools")}</legend>
      {groups.map((group) => (
        <div key={group.name} className="ac-detail-section">
          <h4 className="ac-detail-heading">
            {group.name === "builtin" ? t("agents.toolGroupBuiltin") : group.name}
          </h4>
          {group.entries.map((entry) => (
            <div key={entry.name} className="ds-field">
              <label className="cx-check-label">
                <input type="checkbox" checked={selected.includes(entry.name)} onChange={() => toggle(entry.name)} />{" "}
                <span className="ds-mono">{label(entry)}</span>
                {entry.requires_approval && <span className="ds-badge ds-badge--warning">{t("agents.needsApproval")}</span>}
                {entry.restricted_to_agents && <span className="ds-badge">{t("agents.toolRestricted")}</span>}
              </label>
              {entry.description && <span className="ds-help">{entry.description}</span>}
              {reason(entry.name) && <span className="ds-help" role="alert">{reason(entry.name)}</span>}
            </div>
          ))}
        </div>
      ))}
      {unavailable.map((name) => (
        <div key={name} className="ds-field">
          <label className="cx-check-label">
            <input type="checkbox" checked onChange={() => toggle(name)} />{" "}
            <span className="ds-mono">{name}</span>{" "}
            <span className="ds-badge ds-badge--danger">{t("agents.toolUnavailable")}</span>
          </label>
          {reason(name) && <span className="ds-help" role="alert">{reason(name)}</span>}
        </div>
      ))}
    </fieldset>
  );
}
